import { getDuration, getGenresNames } from '@/utility/content';
import getLink from '@/utility/routes';
import { ROUTE_SHOWS_AND_MOVIES_MOVIE } from '@/constants/routes';

export default data => {
  const url = data?.slug ? getLink(ROUTE_SHOWS_AND_MOVIES_MOVIE, { movie_id: data?.slug }) : '';

  return {
    '@type': 'Movie',
    name: data?.content_title,
    description: data?.overview,
    duration: {
      '@type': 'Duration',
      name: data?.duration ? getDuration(data.duration) : '',
    },
    contentRating: data?.rating,
    datePublished: data?.first_air_date,
    genre: data?.genres?.length ? getGenresNames(data.genres) : '',
    thumbnailUrl: data?.thumbnail,
    image: data?.thumbnail,
    typicalAgeRange: data?.rating,
    url,
  };
};
